package org.lennycodes.hldi.pages.admin

import kotlinx.coroutines.await
import org.lennycodes.hldi.backend.FirebaseService
import org.lennycodes.hldi.backend.collection
import org.lennycodes.hldi.backend.deleteDoc
import org.lennycodes.hldi.backend.deleteObject
import org.lennycodes.hldi.backend.doc
import org.lennycodes.hldi.backend.getDownloadURL
import org.lennycodes.hldi.backend.ref
import org.lennycodes.hldi.backend.uploadBytes
import org.lennycodes.hldi.data.ResourceDocument
import org.w3c.files.File

data class UploadedResourceFile(
    val url: String,
    val storagePath: String
)

suspend fun uploadResourceDocument(file: File, id: String): UploadedResourceFile {

    val storagePath = "resources/$id-${file.name}"

    val fileRef = ref(FirebaseService.storage, storagePath)

    uploadBytes(fileRef, file).await()

    val downloadUrl = getDownloadURL(fileRef).await()

    return UploadedResourceFile(
        url = downloadUrl,
        storagePath = storagePath
    )
}
suspend fun deleteResource(resource: ResourceDocument) {

    // Delete Firestore document
    deleteDoc(
        doc(
            collection(FirebaseService.db, "resources"),
            resource.id
        )
    ).await()

    // Delete the file from Storage using the actual stored path
    if (resource.storagePath.isNotBlank()) {
        try {
            val fileRef = ref(FirebaseService.storage, resource.storagePath)
            deleteObject(fileRef).await()
        } catch (e: Throwable) {
            console.error("Storage delete failed: ${e.message}")
        }
    }
}